import React from "react";
import CustomCheckBox from "../CustomCheckBox/CustomCheckBox";

function SidebarValues({
  styles,
  labels,
  checkboxData,
  handleCheckboxChange,
  notes,
  handleChangeNotes,
}) {
  return (
    <div className={styles.values}>
      <h3>{labels.title}</h3>
      <p className={styles.muted}>
        {labels.para1} <strong>{labels.para2}</strong>, {labels.para3}
      </p>
      <div className={styles.hint}>
        ℹ️ <span>{labels.info}</span>
      </div>
      <div className={styles.choices}>
        {checkboxData.map((group) => (
          <label key={group.name} className={styles.choice}>
            <CustomCheckBox
              data={group.data}
              name={group.name}
              onCheckChange={handleCheckboxChange}
              selectedValues={group.selectedValues}
            />
          </label>
        ))}
      </div>
      <label htmlFor="notes" className={styles.muted}>
        {labels.feedbackLabel}
      </label>
      <textarea
        value={notes}
        rows={7}
        onChange={handleChangeNotes}
        name="notes"
        placeholder="Example: Gas condensing boiler 2004, roof insulated 2012…"
      />
    </div>
  );
}

export default SidebarValues;


